import rest from "@/rest-client";
import vuexStore from "@/store/customSaveStore";

export const dataDisposalPeriod = vuexStore({
  namespaced: true,
  path: "/datasource-data/disposal-period",
  state: {
    editedData: null,
  },
  getters: {
    editedData: (state) => state.editedData,
  },
  mutations: {
    editedData: (state, value) => (state.editedData = value),
  },
  actions: {
    async save({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = {
          ...payload,
          item: getters.editedData,
        };

        const response = await rest.put(`/datasource-data/disposal-period`, payload);

        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
